import { render, staticRenderFns } from "./penalty-detail.vue?vue&type=template&id=67837a7a&scoped=true&"
import script from "./penalty-detail.vue?vue&type=script&lang=ts&"
export * from "./penalty-detail.vue?vue&type=script&lang=ts&"
import style0 from "./penalty-detail.vue?vue&type=style&index=0&id=67837a7a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67837a7a",
  null
  
)

export default component.exports